import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router'

import { SharedModule } from '../shared/shared.module'

import { FacetComponent } from './components/facet'
import { FacetListComponent } from './components/facet-list'
import { FacetgroupListComponent } from './components/facetgroup-list'
import { FacetgroupComponent } from './components/facetgroup'
import { ChipComponent } from './components/chip'
import { ChipListComponent } from './components/chip-list'

import { FacetRoutingService } from './services/facet-routing-service'

@NgModule({
  imports: [
    RouterModule,
    SharedModule
  ],
  declarations: [
    FacetComponent,
    FacetListComponent,
    FacetgroupComponent,
    FacetgroupListComponent,
    ChipComponent,
    ChipListComponent
  ],
  providers: [
    FacetRoutingService
  ],
  exports: [
    FacetComponent,
    FacetListComponent,
    FacetgroupComponent,
    FacetgroupListComponent,
    ChipComponent,
    ChipListComponent
  ]
})
export class FacetsModule {}
